import { GET_PROJECT_ITEM_CMS_API } from '../commons/constants';
import { ProjectItemTypes } from '../types';
import { PaginationResponseTypes } from '../types/response';
import { get } from './axios';

export const fetchProjectItemsCms = async (request: {
  keyword?: string;
  lang?: string;
  published?: boolean;
  types?: string;
  projectId?: string | number;
  size?: number;
}): Promise<PaginationResponseTypes<ProjectItemTypes[]>> => {
  let res: any;
  try {
    res = await get(`${GET_PROJECT_ITEM_CMS_API}`, { params: { ...request } });
  } catch (e) {
    console.error(e);
    return null;
  }
  return res;
};
